/**
 * Global tuning for the 3D scene. Every magic number that shapes the look or feel
 * of the universe lives here so the behaviour can be dialled in from one place.
 */
export const sceneConfig = {
  camera: {
    fieldOfView: 55,
    near: 0.1,
    far: 4000,
    defaultDistance: 230,
    defaultPolarAngle: 1.15,
    minDistance: 40,
    maxDistance: 520,
    parallaxStrength: 26,
    parallaxEase: 0.045,
    autoOrbitSpeed: 0.012,
  },
  motion: {
    orbitTimeScale: 1,
    idleCometDelaySeconds: 30,
    shootingStarIntervalSeconds: 9,
  },
  bloom: {
    strength: 0.95,
    radius: 0.55,
    threshold: 0.12,
  },
  starfield: {
    count: 2600,
    radius: 1800,
    minSize: 1.1,
    maxSize: 3.4,
  },
  particles: {
    ambientCount: 700,
    ambientRadius: 320,
    trailPointsPerLink: 60,
  },
  performance: {
    maxPixelRatio: 2,
    mobilePixelRatio: 1.5,
    mobileStarDivisor: 2.2,
    mobileParticleDivisor: 2.4,
  },
  warp: {
    zoomDurationSeconds: 1.4,
    navigateDelaySeconds: 1.25,
  },
} as const
